import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Expedientes from './pages/Expedientes';
import Usuarios from './pages/Usuarios';
import PagosOficina from './pages/PagosOficina';
import Reportes from './pages/Reportes';
import Importacion from './pages/Importacion';
import ExpedienteDetalle from './pages/ExpedienteDetalle';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/expedientes"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Expedientes />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/expedientes/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ExpedienteDetalle />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/usuarios"
              element={
                <ProtectedRoute roles={['admin']}>
                  <Layout>
                    <Usuarios />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/pagos-oficina"
              element={
                <ProtectedRoute roles={['admin', 'auditor']}>
                  <Layout>
                    <PagosOficina />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/reportes"
              element={
                <ProtectedRoute roles={['admin', 'auditor']}>
                  <Layout>
                    <Reportes />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/importacion"
              element={
                <ProtectedRoute roles={['admin']}>
                  <Layout>
                    <Importacion />
                  </Layout>
                </ProtectedRoute>
              }
            />

            {/* Redirect unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
